module.exports = __webpack_public_path__ + "media/20.3b8c3d5c.wav";